<div class="row" style="margin-top: 5px;margin-bottom: 0px;">
  <div class="two columns">
    <div class="label">
      {{'Type' | translate}}
    </div>
    <div class="field">
      <select
        soho-dropdown noSearch
        [attributes]="typeAutomationId"
        bindId="type"
        [(ngModel)]="computeRow.type"
        (change)="clearField()"
        >
        @for (item of types; track item) {
          <option [value]="item.value">{{item.label}}</option>
        }
      </select>
    </div>
  </div>
  <div class="three columns">
    @if (computeRow.type === 'field') {
      <lm-filter-builder-field-lookup
        id="computeField"
        [index]="index"
        [qualifier]="computeRow.field"
        [builderOptions]="builderOptions"
        attr.data-automation-id="lm-compute-builder-row-compute-field-{{index}}"
        position="computeField"
        mode="Fields"
        (fieldSelectionEvent)="handleFieldLookUpEvent()"
        >
      </lm-filter-builder-field-lookup>
    } @else {
      <div class="field">
        <label soho-label>{{'LiteralValue' | translate}}</label>
        <input
          class="input-mm"
          [attr.id]="literalId"
          [attr.bindId]="computeRow.field"
          type="text"
          [(ngModel)]="computeRow.field.text"
          (input)="handleFieldChange()"
          [attr.data-automation-id]="literalAutomationId"
          />
        </div>
      }
    </div>
    <div class="two columns">
      <div class="field">
        <label soho-label>{{'FunctionLabel' | translate}}</label>
        <select
          soho-dropdown noSearch
          bindId="function"
          [(ngModel)]="computeRow.function"
          [disabled]="computeRow.type !== 'field'"
          (change)="handleFieldChange()"
          [attributes]="functionAutomationId"
          >
          @for (item of functions; track item) {
            <option [value]="item.value">{{item.label}}</option>
          }
        </select>
      </div>
    </div>
    <div class="one column">
      <div class="field">
        <label soho-label>{{ 'OperatorsLabel' | translate }}</label>
        <select
          soho-dropdown noSearch
          bindId="operator"
          [(ngModel)]="computeRow.operator"
          (change)="onOperatorChange()"
          [attributes]="operatorAutomationId"
          >
          @for (item of operators; track item) {
            <option [value]="item.value">{{item.label}}</option>
          }
        </select>
      </div>
    </div>

    <div class="one column">
      <div class="field">
        <div class="label">
          &nbsp;
        </div>
        <button soho-button="icon"
          (click)="onRemoveButtonEvent()"
          icon="delete"
          title="{{'Delete' | translate }}"
          [attr.data-automation-id]="deleteAutomationId"
          ><span #LmButtonIcon class="lm-button-icon" role="presentation" aria-hidden="true"></span></button>
        </div>
      </div>
    </div>
